import {
    RequestKeys,
} from 'app/hooks/useRequest'

import StatusHandler from 'app/shared-components/StatusHandler'
import ChangeHistory from 'app/shared-components/ChangeHistory'

import config from 'app/requests/Logger.requests'
import useGetLoggerByLoggerNumber from '../hooks/useGetLoggerByLoggerNumber'

const GatewayChangeHistory = ({
    id: loggerNumber,
}: { id: string }) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetLoggerByLoggerNumber(loggerNumber)

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <ChangeHistory
                id={data?.id}
                requestKey={RequestKeys.getLoggerModifications}
                config={config.modifications}
                configName="LoggerChangeHistoryTable"
                name="LoggerChangeHistory"
                labelPrefixForChangedColumn={['Logger']}
            />
        </StatusHandler>
    )
}

export default GatewayChangeHistory
